import PropTypes from 'prop-types';
import clsx from 'clsx';

import ClosedCaptions from '../../Icons/ClosedCaptions';
import Pause from '../../Icons/Pause';
import Play from '../../Icons/Play';
import Replay from '../../Icons/Replay';
import Skip from '../../Icons/Skip';
import VolumeOff from '../../Icons/VolumeOff';
import VolumeOn from '../../Icons/VolumeOn';
import usePlayerControls from './hooks/usePlayerControls';
import { CONTROLS } from './constants';
import useStyles from './playerControls.styles';

const PlayerControls = ({
  controls,
  muted,
  onSkip,
  showCC,
  playing,
  toggleMuted,
  stopPlaying,
  togglePlaying,
  toggleShowCC,
  replay,
}) => {
  const styles = useStyles();
  const { onSkipButtonClick } = usePlayerControls(onSkip, stopPlaying);

  return (
    <div className={styles.wrapper}>
      {controls[CONTROLS.PLAY_PAUSE] && (
        <button type="button" className={styles.button} onClick={togglePlaying}>
          {playing ? (
            <Pause className={styles.buttonIcon} />
          ) : (
            <Play className={styles.buttonIcon} />
          )}
        </button>
      )}
      {/* toggle mute button */}
      {controls[CONTROLS.VOLUME] && (
        <button type="button" className={styles.button} onClick={toggleMuted}>
          {muted ? (
            <VolumeOff className={styles.buttonIcon} />
          ) : (
            <VolumeOn className={styles.buttonIcon} />
          )}
        </button>
      )}
      {/* CC button */}
      {controls[CONTROLS.SHOW_CC] && (
        <button type="button" className={styles.button} onClick={toggleShowCC}>
          <ClosedCaptions
            className={clsx(styles.buttonIcon, !showCC && styles.showCCOff)}
          />
        </button>
      )}
      {/* replay button */}
      {controls[CONTROLS.REPLAY] && (
        <button type="button" className={styles.button} onClick={replay}>
          <Replay className={styles.buttonIcon} />
        </button>
      )}
      {/* skip button */}
      {controls[CONTROLS.SKIP] && (
        <button
          type="button"
          className={styles.button}
          onClick={onSkipButtonClick}
        >
          <Skip className={styles.buttonIcon} />
        </button>
      )}
    </div>
  );
};

PlayerControls.propTypes = {
  controls: PropTypes.shape({
    skip: PropTypes.bool,
    play_pause: PropTypes.bool,
    volume: PropTypes.bool,
  }),
  muted: PropTypes.bool.isRequired,
  onSkip: PropTypes.func,
  playing: PropTypes.bool.isRequired,
  showCC: PropTypes.bool.isRequired,
  toggleMuted: PropTypes.func,
  stopPlaying: PropTypes.func.isRequired,
  togglePlaying: PropTypes.func,
  toggleShowCC: PropTypes.func,
  replay: PropTypes.func,
};

PlayerControls.defaultProps = {
  controls: undefined,
  onSkip: undefined,
  toggleMuted: undefined,
  togglePlaying: undefined,
  toggleShowCC: undefined,
  replay: undefined,
};

export default PlayerControls;
